import type {DataGridRow} from '@dms/api/core';

import {CUSTOMER_INSIGHTS_GRID_FIELDS} from './customerInsightsGridFields';
import {readDataGridCellKey} from './readDataGridCellKey';

export function getBusinessCaseRowType(row: DataGridRow) {
  return readDataGridCellKey(row, CUSTOMER_INSIGHTS_GRID_FIELDS.businessCase.type);
}
